import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import ButtonCircle from "../../../../components/Common/ButtonCircle";
import {MissingType} from "../../../../db/models/extra";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import {openAlert} from "../../../../slices/alert";
import Button from "../../../../components/Common/Button";
import {useTranslation} from "react-i18next";
import {updateUser} from "../../../../api/user";
import {selectUser} from "../../../../slices/profile";

export const StudentSettingsPhone = () => {
    const [editPhone, setEditPhone] = useState(false);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    const phone = user?.phone;
    const {register, handleSubmit, errors} = useForm<MissingType>();
    const loading = false;

    const handleUpdatePhone = (form) => {
        updateUser({phone: form.phone})
            .then(() => {
                setEditPhone(false);
            })
            .catch((error) => {
                dispatch(
                    openAlert({type: "error", message: t("alert_generic_error")})
                );
            });
    };

    return (
        <div className="studentSettingsPhone mb30">
            <div className="studentSettingsPhone__header">
                <label className="label">{t("student_settings_phone")}</label>
                {!editPhone && (
                    <ButtonCircle light onClick={() => setEditPhone(true)}>
                        <EditIcon/>
                    </ButtonCircle>
                )}
                {editPhone && (
                    <ButtonCircle light onClick={() => setEditPhone(false)}>
                        <ClearIcon/>
                    </ButtonCircle>
                )}
            </div>
            {!editPhone && <p className="body">{phone}</p>}
            {editPhone && (
                <form onSubmit={handleSubmit(handleUpdatePhone)}>
                    <div className="element">
                        <div className="label">{t("student_settings_phone_label")}</div>
                        <input
                            type="phone"
                            placeholder={t("student_settings_phone_ph")}
                            name="phone"
                            ref={register({required: true})}
                        />
                        {errors.phone && (
                            <span className="error">{t("student_settings_phone_error")}</span>
                        )}
                    </div>
                    <Button type="submit" loading={loading} filled>
                        {t("student_settings_phone_submit")}
                    </Button>
                </form>
            )}
            {/* <div id="recaptchaContainer" hidden></div> */}
            {/* {editPhone && enteringCode && (
				<div className="studentSettingsPhone__code">
					<div className="element">
						<div className="label">{t("student_settings_phoneCode_label")}</div>
						<input
							type="text"
							placeholder={t("student_settings_phoneCode_ph")}
							value={code}
							onChange={(e) => setCode(e.target.value)}
						/>
					</div>
					<Button disabled={!code} onClick={onCodeSent} type="submit">
						{t("student_settings_phoneCode_submit")}
					</Button>
				</div>
			)} */}
        </div>
    );
};
